import borders from 'assets/theme/base/borders';
import pxToRem from 'assets/theme/function/px-to-rem';

const { borderRadius } = borders;

const sideNav = {
    styleOverrides: {
        root: {
            width: pxToRem(0),
            //whiteSpace: 'nowrap',
            border: 'none',
        },

        paper: {
            width: pxToRem(152),
            backgroundColor: 'transparent',
            height: `calc(100vh - ${pxToRem(32)})`,
            marginLeft: pxToRem(0),
            borderRadius: borderRadius.xl,
            border: 'none',
        },

        paperAnchorDockedLeft: {
            borderRight: 'none',
        },
    },
};

export default sideNav;
